/* eslint-env jquery */

import form from "./_form.js";

function getRowsWithHelp() {
  return form.getFormRows().filter(".help");
}

function makeHelpButton() {
  return $('<span class="help-button">?</span>');
}

function makeHelpButtons() {
  let formRows = getRowsWithHelp();
  formRows.each(function () {
    let $row = $(this);
    let $button = $row.children(".helpButton");
    if ($button.length === 0) {
      $row.append(makeHelpButton());
    }
  });
}

export default { getRowsWithHelp, makeHelpButton, makeHelpButtons };
